import admin from '@/router/admin/admin'
import attestation from '@/router/attestation'
import common from '@/router/common'
import pdf from '@/router/pdf'

export default class RouterUtils {
  static router

  static getDefaultPageOfRole (role) {
    switch (role) {
      case 'ROLE_ADMIN':
        return 'AdminIndex'
      case 'ROLE_STUDENT':
        return 'AttestationIndex'
    }
  }

  static getMenuByRole (roles) {
    if (!roles) {
      return []
    }
    let role = roles[0]
    let pages = []
    switch (role) {
      case 'ROLE_ADMIN':
        pages = [
          {name: 'AdminIndex', title: 'Админка', exact: true},
          {
            name: 'AdminQuestions',
            title: 'Вопросы',
            children: [
              {name: 'AdminQuestionsTestIndex', title: 'Тестирование'},
              {name: 'AdminQuestionsThematicIndex', title: 'Тематические'},
              {name: 'AdminQuestionsPracticeIndex', title: 'Практические'}
            ]
          },
          {name: 'AdminOrganizationIndex', title: 'Организации'},
          {name: 'AdminGroupIndex', params: {orgId: null}, title: 'Группы'}
        ]
        break
      case 'ROLE_STUDENT':
        pages = [
          {name: 'AdminIndex', title: 'Главная'}
        ]
        break
    }
    return this.filterRoute(pages)
  }

  static getRoutes () {
    return [].concat(admin, attestation, pdf, common)
  }

  static filterRoute (pages) {
    return RouterUtils.getRoutes().filter(route => {
      let p = pages.filter(page => page.name === route.name)
      if (p.length > 0) {
        if (p[0].children) {
          route.children = this.filterRoute(p[0].children)
        }
        route.meta.title = p[0].title
        route.meta.params = p[0].params ? p[0].params : {}
        route.meta.hidden = p[0].hidden ? p[0].hidden : false
        route.meta.exact = p[0].exact ? p[0].exact : false
        return true
      }
      return false
    })
  }

  static push (name) {
    this.router.push({name: name})
  }
}

export const Template = {
  MATERIAL: 'material',
  SIMPLE: 'simple'
}



// WEBPACK FOOTER //
// ./src/router/RouterUtils.js